import BaseApi from "./BaseApi";

export default class TaxInvoiceService extends BaseApi {

    constructor(){
        super();
    }


    async productServices(keyword)
    {
        return this.http.get(`${this.baseUrl}/tax-invoices/catalogs/products?keyword=${keyword}`)
        .catch(this.handleErrorResponse);
    }

    async units()
    {
        return this.http.get(`${this.baseUrl}/tax-invoices/catalogs/units`)
        .catch(this.handleErrorResponse);
    }

    async paymentsMethods()
    {
        return this.http.get(`${this.baseUrl}/tax-invoices/catalogs/payment-methods`)
        .catch(this.handleErrorResponse);
    }

    async cfdiTypes()
    {
        return this.http.get(`${this.baseUrl}/tax-invoices/catalogs/cfdi-types`)
        .catch(this.handleErrorResponse);
    }

    async paymentForms()
    {
        return this.http.get(`${this.baseUrl}/tax-invoices/catalogs/payment-forms`)
        .catch(this.handleErrorResponse);
    }

    async cfdiUses()
    {
        return this.http.get(`${this.baseUrl}/tax-invoices/catalogs/cfdi-uses`)
        .catch(this.handleErrorResponse);
    }

    async fiscalRegimens()
    {
        return this.http.get(`${this.baseUrl}/tax-invoices/catalogs/fiscal-regimens`)
        .catch(this.handleErrorResponse);
    }

    async readCertificate(business, file)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/customers/read-tax-status-certificate`,file,{headers: { "Content-Type": "multipart/form-data"}})
        .catch(this.handleErrorResponse);
    }

}